<script lang="ts">
	import Badge from '$lib/components/ui/badge/badge.svelte';
	import Skeleton from '$lib/components/ui/skeleton/skeleton.svelte';
</script>

<div
	class="border-darkTertiary bg-darkSecondary hover:border-darkQuaternary group relative h-80 w-full overflow-hidden rounded-lg border p-6 shadow-sm transition-all"
>
	<div class="card-spotlight -top-32 z-0 aspect-square h-80" />
	<div class="grid h-full w-full grid-rows-5 items-center justify-center gap-4">
		<div class="relative row-span-3 flex h-full w-full flex-row items-center justify-center">
			<div
				class="border-darkTertiary bg-darkSecondary mx-auto flex h-28 w-48 flex-col items-center justify-center gap-6 rounded-lg border p-4"
			>
				<Badge
					class="bg-purple-600 text-[10px] font-normal hover:bg-purple-500 group-hover:bg-purple-500"
					>LEVEL 1 TIP</Badge
				>
				<div class="flex w-full flex-col items-center justify-center gap-2">
					<Skeleton class="h-1.5 w-32 rounded-md" />
					<Skeleton class="h-1.5 w-16 rounded-md" />
					<Skeleton class="h-1.5 w-full rounded-md" />
				</div>
			</div>
		</div>
		<div
			class="row-span-2 mx-auto flex h-full w-full max-w-sm flex-col items-center justify-center gap-2 text-center"
		>
			<h3 class="text-xl font-normal">Matchup Tips</h3>
			<p class="text-lightTertiary">Let Meeko guide you through rough and easy matchups.</p>
		</div>
	</div>
</div>
